<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Date Ranges</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                    data-vv-name="form.tranDateFrom"></cal-picker>
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                    data-vv-name="form.tranDateTo"></cal-picker>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Filters</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('form.branch')" :data-vv-as="labels.branch"
                    data-vv-name="form.branch" append-icon="mdi-magnify" @click:append="showBranchHelpList=true" @click="showBranchHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.dept" :label="labels.dept" :error-messages="errors.collect('form.dept')" :data-vv-as="labels.dept"
                    data-vv-name="form.dept" append-icon="mdi-magnify" @click:append="showDeptHelpList=true" @click="showDeptHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('form.polType')" :data-vv-as="labels.polType"
                    data-vv-name="form.polType" append-icon="mdi-magnify" @click:append="showPolTypeHelpList=true" @click="showPolTypeHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.agent" :label="labels.agent" :error-messages="errors.collect('form.agent')" :data-vv-as="labels.agent"
                    data-vv-name="form.agent" append-icon="mdi-magnify" @click:append="showBillAcctHelpList=true" @click="showBillAcctHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="form.riType" :items="riTypeList" :label="labels.riType" item-text="label" item-value="value" @change="riTypeChanged"/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.riCo" :label="labels.riCo" :error-messages="errors.collect('form.riCo')" :data-vv-as="labels.riCo"
                    data-vv-name="form.riCo" append-icon="mdi-magnify" @click:append="showRiCoHelpList=true" @click="showRiCoHelpList=true" readonly
                    :disabled="riCoDisabled"/>
                </v-flex>
                <!-- <v-flex xs12 sm6>
                  <v-select single v-model="form.uwYrFrom" :label="labels.uwYrFrom" :data-vv-as="labels.uwYrFrom" data-vv-name="uwYrFrom" :items="years"></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select single v-model="form.uwYrTo" :label="labels.uwYrTo" :data-vv-as="labels.uwYrTo" data-vv-name="uwYrTo" :items="years" :error-messages="errors.collect('uwYrTo')" v-validate="doValidateToUWYear"></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select single v-model="form.lossYrFrom" :label="labels.lossYrFrom" :data-vv-as="labels.lossYrFrom" data-vv-name="lossYrFrom" :items="years"></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select single v-model="form.lossYrTo" :label="labels.lossYrTo" :data-vv-as="labels.lossYrTo" data-vv-name="lossYrTo" :items="years" :error-messages="errors.collect('lossYrTo')" v-validate="doValidateToLossYear"></v-select>
                </v-flex> -->
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Report Settings</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
                    data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
    <v-dialog v-model="showDeptHelpList" width="900px" persistent>
      <multi-dept-help-list :dept="form.dept" @close="doClose" @doAssign="doAssignDept($event)" />
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list :pt="form.polType" @close="doClose" @doAssign="doAssignPolType($event)" />
    </v-dialog>
    <v-dialog v-model="showBillAcctHelpList" width="900px" persistent>
      <multi-bill-acct-no-help-list :intr="form.agent" @close="doClose" @doAssign="doAssignBillAcct($event)" />
    </v-dialog>
    <v-dialog v-model="showRiCoHelpList" width="900px" persistent>
      <multi-ri-co-help-list :riType="form.riType" :refresh="showRiCoHelpList" @close="doClose" @doAssign="doAssignRiCo($event)" />
    </v-dialog>
  </page>
</template>
<script>
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiRiCoHelpList from '@/components/core/common/dialog/MultiRiCoHelpList'
import MultiBillAcctNoHelpList from '@/components/core/common/dialog/MultiBillAcctNoHelpList.vue'
import { riTypes } from '@/const/common'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [
    commonAjaxMixin,
    MessageMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiDeptHelpList,
    MultiPolTypeHelpList,
    MultiBillAcctNoHelpList,
    MultiRiCoHelpList
  },
  data() {
    return {
      menu: {},
      showBranchHelpList: false,
      showDeptHelpList: false,
      showPolTypeHelpList: false,
      showBillAcctHelpList: false,
      showRiCoHelpList: false,
      submitting: false,
      form: {
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        branch: 'All',
        dept: 'All',
        polType: 'All',
        agent: 'All',
        riType: 'D',
        riCo: 'All',
        uwYrFrom: new Date().getFullYear(),
        uwYrTo: new Date().getFullYear(),
        lossYrFrom: new Date().getFullYear(),
        lossYrTo: new Date().getFullYear(),
        pbPrtParam: false,
        format: 'PDF'
      },
      labels: {
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'To',
        branch: 'Branch',
        dept: 'Department',
        polType: 'Policy Type',
        agent: 'Billing Account',
        riType: 'RI Type',
        riCo: 'RI Company',
        uwYrFrom: 'Underwriting Year From',
        uwYrTo: 'To',
        lossYrFrom: 'Loss Year From',
        lossYrTo: 'To',
        pbPrtParam: 'Print Run Time Parameters',
        export: 'Export To',
        reportType: 'Report Type'
      },
      supportedFormat: []
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    riTypeList() {
      const list = Object.freeze(riTypes)
      return Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
    },
    riCoDisabled() {
      return this.form.riType === 'D'
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    years() {
      const tempYearList = []
      const year = new Date().getFullYear() + 5
      tempYearList.push(0)
      for (var i = 1999; i <= year; i++) {
        tempYearList.push(i)
      }
      return tempYearList
    },
    doValidateToLossYear() {
      if (this.form.lossYearFrom !== 0) {
        return '|valMaxLossYear:' + this.form.lossYrFrom
      } else {
        return ''
      }
    },
    doValidateToUWYear() {
      if (this.form.uwYearFrm !== 0) {
        return '|valMaxUWYear:' + this.form.uwYrFrom
      } else {
        return ''
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.clmRIBord
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async riTypeChanged() {
      this.form.riCo = 'All'
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showBranchHelpList = false
      this.showDeptHelpList = false
      this.showPolTypeHelpList = false
      this.showBillAcctHelpList = false
      this.showRiCoHelpList = false
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    async doAssignDept(obj) {
      this.form.dept = []
      this.form.dept = obj.finalSelectedItems.toString()
    },
    async doAssignPolType(obj) {
      this.form.polType = []
      this.form.polType = obj.finalSelectedItems.toString()
    },
    async doAssignBillAcct(obj) {
      this.form.agent = []
      this.form.agent = obj.finalSelectedItems.toString()
    },
    async doAssignRiCo(obj) {
      this.form.riCo = []
      this.form.riCo = obj.finalSelectedItems.toString()
      // if (this.form.riCo === 'All') {
      //   this.form.riCo = ''
      // }
    }
  },
  created() {
    this.$validator.extend('valMaxLossYear', {
      getMessage(field, args) {
        return 'Loss Year To cannot be earlier than Loss Year From'
      },
      validate(value, args) {
        let dateSelected = args[0]
        if (value < dateSelected) {
          return false
        } else return true
      }
    })
    this.$validator.extend('valMaxUWYear', {
      getMessage(field, args) {
        return 'Underwriting Year To cannot be earlier than Underwriting Year From'
      },
      validate(value, args) {
        let dateSelected = args[0]
        if (value < dateSelected) {
          return false
        } else return true
      }
    })
  }
}
</script>
